import ArrowLeftSvg from '@icons/arrow-left.svg?react';
import { useAppSelector } from '@store/hooks';
import { selectNavigatorBackState, selectNavigatorState } from '@store/reducers/appSlice';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router';

interface MobileTopNavigationProps {
  onBack?: () => void;
  backTitle?: ReactNode;
  noBorder?: boolean;
}

const MobileTopNavigation: FC<MobileTopNavigationProps> = ({ onBack, backTitle, noBorder }) => {
  const navigateOn = useAppSelector(selectNavigatorState);
  const navigateBackOff = useAppSelector(selectNavigatorBackState);
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
      return;
    } else {
      navigate(-1);
    }
  };

  if (navigateBackOff) return null;

  if (!navigateOn) {
    return (
      <div
        className={classNames(
          'fixed lg:absolute top-0 left-0 right-0 flex justify-start items-center gap-1 px-3 py-3 z-50 w-full',
          {
            'shadow shadow-base-100/30': !noBorder,
            'bg-transparent': !backTitle,
            'bg-gradient-to-br from-base-200/55 to-base-200/25 border-b border-base-100/55 backdrop-blur-2xl':
              backTitle,
          },
        )}
      >
        <button
          className="flex items-center bg-base-200/55 backdrop-blur-xl rounded-full p-2 cursor-pointer active:scale-95 transition-transform duration-300"
          onClick={handleBackClick}
        >
          <ArrowLeftSvg className="h-5 w-5 stroke-current" />
        </button>
        {backTitle && <span className="ml-2 font-medium">{backTitle}</span>}
      </div>
    );
  }
};

export default MobileTopNavigation;
